module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "slider-card"
  }, [_c('v-flex', {
    staticClass: "track-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "track-cover",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.item.album_type == 'playlist') ? _c('div', {
    staticClass: "playlist-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/playlist.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "track-image",
    style: ({
      'background-image': 'url(' + _vm.item.cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "track-actions",
    class: {
      playing: _vm.isPlaying
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    },
    on: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }), _vm._v(" "), (!_vm.isPlaying || _vm.$store.state.player.isPaused) ? _c('v-btn', {
    staticClass: "play-button",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.playSong()
      }
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1) : _c('v-btn', {
    staticClass: "play-button",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.pauseSong()
      }
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": ("/" + (_vm.item.album_type) + "/" + (_vm.item.slug))
    }
  }, [_c('p', {
    staticClass: "track-count"
  }, [_vm._v(_vm._s(_vm.item.tracks.length) + " tracks")])])], 1)], 1)], 1), _vm._v(" "), (_vm.showDownloadModal) ? _c('download-modal', {
    attrs: {
      "item": _vm.item,
      "dismiss": _vm.dismissDownloadModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2996edde","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/albumslidecard.vue
// module id = 1661
// module chunks = 180